import './Card.scss';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import Svg from '@justgiving/svg';

import { chevronRightSlimIcon } from '@justgiving/icons/src/index.js';
import { LocationDescriptor } from 'history';

interface LinkProps {
  name?: string;
  children?: React.ReactNode;
  to: LocationDescriptor;
  className?: string;
}

const ChevronRightIcon = () => (
  <Svg
    markup={chevronRightSlimIcon}
    className="jg-icon--slim jg-pull-right jg-fill--empress"
  />
);

export const Card: FunctionComponent<LinkProps> = ({ children, to }) => {
  return (
    <div className={'wrapper jg-display-flex jg-flex-aic jg-flex-jcb '}>
      {children}
      <Link to={to} className="chevronButton jg-color--empress">
        <ChevronRightIcon />
      </Link>
    </div>
  );
};
